// Module
var code = "<span class=\"br-body-2\">{{$ctrl.displayTime}}</span> ";
// Exports
export default code;